var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolunteerActivism(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11C2.4 11 1.5 11.9 1.5 13V20C1.5 21.1 2.4 22 3.5 22C4.6 22 5.5 21.1 5.5 20V13C5.5 11.9 4.6 11 3.5 11Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.3C10.5 3.45 11.95 2 13.8 2C14.84 2 15.85 2.49 16.5 3.25C17.15 2.49 18.16 2 19.2 2C21.05 2 22.5 3.45 22.5 5.3C22.5 7.4 20 9.81 17.17 12.39C16.79 12.74 16.2 12.74 15.82 12.39C13 9.81 10.5 7.4 10.5 5.3Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.49 17H13.66C13.55 17 13.44 16.98 13.33 16.94L11.86 16.43C11.6 16.34 11.47 16.06 11.56 15.8C11.65 15.54 11.94 15.4 12.2 15.5L13.32 15.93C13.43 15.97 13.56 16 13.68 16H16.31C16.96 16 17.49 15.47 17.49 14.82C17.49 14.33 17.18 13.89 16.72 13.71L9.8 11.13C9.58 11.04 9.34 11 9.1 11H7.5V20.02L13.87 21.83C14.28 21.95 14.72 21.93 15.12 21.78L22.5 19C22.5 17.89 21.6 17 20.49 17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteerActivism);
export default __webpack_public_path__ + "static/media/VolunteerActivism.fcf0a7ceb8aeb4234976a00a9eebd5da.svg";
export { ForwardRef as ReactComponent };